export const checkStatus = response => {
  const { ok, status, statusText } = response;

  if (!ok) {
    const error = new Error(statusText);
    error.response = response;
    error.code = status;

    // attach the parsed response json to the error if possible
    return response.json().then(
      json => {
        error.json = json;
        throw error;
      },
      () => {
        error.json = {
          message: statusText,
        };
        throw error;
      },
    );
  }

  return response;
};
